const UNITS = ["B", "KB", "MB", "GB", "TB", "PB"] as const;

/**
 * Format bytes to human-readable string.
 * Accepts both number and bigint (BigIntString from API → convert first).
 */
export function formatBytes(bytes: bigint | number | string, decimals = 2): string {
  const n = typeof bytes === "string" ? BigInt(bytes) : BigInt(bytes.toString());

  if (n === 0n) return "0 B";

  let value = n;
  let unitIndex = 0;

  while (value >= 1024n && unitIndex < UNITS.length - 1) {
    value = value / 1024n;
    unitIndex++;
  }

  // For sub-KB precision, do float math
  const floatValue =
    Number(n) / Math.pow(1024, unitIndex);

  return `${floatValue.toFixed(decimals).replace(/\.?0+$/, "")} ${UNITS[unitIndex]}`;
}
